import { makeEnumClass } from '../base-enum';

export class EnumNivelAcesso extends makeEnumClass() {
    static readonly ORGAO = EnumNivelAcesso.add('1', 'Orgao');
    static readonly ORGAO_VINCULADOS = EnumNivelAcesso.add('2', 'Orgao e Vinculados');
    static readonly UORG = EnumNivelAcesso.add('3', 'Uorg');
    static readonly UPAG = EnumNivelAcesso.add('4', 'Unidade Pagadora');
    static readonly GERAL = EnumNivelAcesso.add('5', 'Geral');
    static readonly UORG_APOIO = EnumNivelAcesso.add('6', 'Unidade de Apoio RH');
    static readonly UORG_SUBORDINADAS = EnumNivelAcesso.add('7', 'UORG e Subordinadas');
    static readonly NAO_IDENTIFICADO = EnumNivelAcesso.add('99', 'Não identificado');
}
